import cx from 'classnames'
import { useState } from 'react'

import { useIGAO } from '../../context'
import {
  cancelledOrCompleted,
  filterItemsByStatus,
  withDivider
} from '../../utils'
import { Issue } from '../issues'

import styles from './item.module.scss'

export function Other ({
  item,
  prevItem,
  selectedIssueId,
  setSelectedIssueId,
  handleInputSubmit,
  handleBatch
}) {
  const { filters } = useIGAO()
  const [ editId, setEditId ] = useState(null)
  const filteredIssues = filterItemsByStatus(item.issues, filters)
  const filled = item.issues?.some(i => !cancelledOrCompleted(i))
  return (
    <>
      {withDivider(prevItem, filters)}
      <div
        className={cx(styles.itemWrap, {
          [styles.filled]: filteredIssues.length > 0
        })}
      >
        <div className={styles.item}>
          <div className={styles.innerBody}>
            <div className={styles.itemLabel}>
              <span
                className={cx({
                  [styles.active]: !filled
                })}
              >
                {item?.label}
              </span>
            </div>
          </div>
        </div>
      </div>
      {filteredIssues?.length > 0 && (
        <div
          className={styles.issueList}
          data-cy='issue-list'
        >
          {filteredIssues?.map(issue => (
            <Issue
              key={issue.id}
              item={item}
              issue={issue}
              selected={selectedIssueId === issue.id}
              setSelectedIssueId={setSelectedIssueId}
              editId={editId}
              setEditId={setEditId}
              handleInputSubmit={handleInputSubmit}
              handleBatch={handleBatch}
            />
          ))}
        </div>
      )}
    </>
  )
}
